import { Box, Checkbox, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, IconButton, MenuItem, Select, Stack, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { ReportSectionContainer, ReportsRightLayout } from '../../InvestorReport/index';
import { getAcountIDBasedonClientID, getDashboardReports, getInvestorReports } from '../../../redux-store/actions/investorReports';
import {
    downloadMultipleFiles,
    formatDate,
    replaceLetterOWithW,
} from '../../../utils/utilityFunctions';
import { TextDatePicker } from '../../onboarding/DatePickerWithTextFeild';
import { MFSubmitButton } from '../../../lib/formik';
import { validationSchemaPortfolioSummary } from '../../../utils/schema';
import { Location } from 'history';
import { useHistory } from 'react-router';
import FormMultiSelect from '../../../lib/formik/FormMultiSelect';
import { getInvestorList, getRMDashBoardMetrics } from '../../../redux-store/actions/userManagement';
import { useEffect, useState } from 'react';
import { AcountIDBasedonClientIDResponse, RmDashboardType } from '../../../redux-store/types/api-types';
import { useFormik } from 'formik';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import Swal from 'sweetalert2';
import LinearProgress from '@mui/material/LinearProgress';
import { useRef } from 'react';
// import * as XLSX from 'xlsx';
import DownloadIcon from '@mui/icons-material/Download'
import { CloseIcon } from '../../customSVGs';
import { getClientL3L4_Config } from '../../../redux-store/actions/investorReports';
import { ClientL3L4_ConfigResponse } from '../../../redux-store/types/api-types'

function LinearBufferLoader() {
    const [progress, setProgress] = useState(0);
    const [buffer, setBuffer] = useState(10);

    const progressRef = useRef<() => void>();
    useEffect(() => {
        progressRef.current = () => {
            if (progress > 100) {
                setProgress(0);
                setBuffer(10);
            } else {
                const diff = Math.random() * 10;
                const diff2 = Math.random() * 10;
                setProgress(progress + diff);
                setBuffer(progress + diff + diff2);
            }
        };
    });

    useEffect(() => {
        if (progress === 0 && buffer === 10) {
            setProgress(10);
            setBuffer(20);
        }
        const timer = setInterval(() => {
            if (progressRef.current) progressRef.current();
        }, 500);

        return () => {
            clearInterval(timer);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <Box sx={{ width: '100%', px: 2 }}>
            <LinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
        </Box>
    );
}

export function DetailedHoldingReport() {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const currentDate = dayjs();
    const [dates, setDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
    const [loading, setLoading] = useState<boolean>(false);
    const [dashBoardMetricsData, setDashBoardMetricsData] = useState<RmDashboardType | null>(null);
    const [l3l4Flag, setL3l4Flag] = useState<any>("N");
    const [L3Report, setl3Report] = useState<boolean>(false);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [previewData, setPreviewData] = useState<string | null>(null);
    const [downloadPreviewLoading, setDownloadPreviewLoading] = useState(false);
    const [previewFormValues, setPreviewFormValues] = useState<any>(null);
    const [wAccountIDFlag, setWAccountIDFlag] = useState<boolean>(false);
    const [wAccountsData, setWAccountsData] = useState<AcountIDBasedonClientIDResponse | null>();
    const [wAccountId, setWAccountId] = useState<any>(null);
    const [investorList, setInvestorList] = useState<any[]>([]);

    useEffect(() => {
        let isComponentActive = true;
        setDashBoardMetricsData(null);
        (async function () {
            try {
                // setLoading(true);
                const response = await dispatch(getInvestorList()) as any;
                if (!isComponentActive) {
                    return;
                }
                setInvestorList(Array.isArray(response) ? response : []);
                // setLoading(false);
            } catch (e) {
                // setLoading(false);
                console.log((e as Error).message);
            }
        })();
        return () => {
            isComponentActive = false;
        };
    }, []);

    const onSubmit = async (date: any, ClientCode: any, setSubmitting: (isSubmitting: boolean) => void) => {
        console.log("first hi ClientCode : ", ClientCode)
        setDates(date);
        let codeToUse;
        if (L3Report) {
            codeToUse = ClientCode;
        } else if (wAccountIDFlag && wAccountId) {
            codeToUse = wAccountId;
        } else {
            codeToUse = ClientCode;
        }
        // console.log("date here", dates)
        // console.log("set loading ", loading)
        try {
            const formattedDate = `${new Date(date).getDate().toString().padStart(2, '0')}/${(new Date(date)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(date).getFullYear()}`;
            // console.log("formattedDate ..>>", formattedDate)
            if (!ClientCode) {
                Swal.fire({
                    confirmButtonText: 'OK',
                    icon: 'info',
                    confirmButtonColor: 'rgb(32, 87, 166)',
                    html: '<p>Please select Investor!   </p>',
                    backdrop: false,
                    focusCancel: true,
                    allowEscapeKey: true,
                });
            }
            else {
                setSubmitting(true);

                // const Fchar = "W"
                // const mClientCode: string = Fchar + ClientCode.slice(1);
                // console.log("modifiedString data: ", mClientCode)

                setLoading(true);
                const res = await dispatch(
                    getDashboardReports({
                        reportName: L3Report ? "DetailedHoldingReportL3" : 'DetailedHoldingReport',
                        ClientCode: codeToUse,
                        ToDate: formattedDate,
                    })
                );
                setLoading(false)
                // console.log(`Generating report for investor with id: ${ClientCode}`);
                // console.log("response ", res)
                downloadMultipleFiles(res);

                formik.setFieldValue('selectedInvestor', formik.values.selectedInvestor);
                enqueueSnackbar('File(s) downloaded successfully.', {
                    variant: 'success',
                    autoHideDuration: 3000,
                });
                setDates(dayjs(currentDate).format("YYYY-MM-DD"));
            }
        }
        catch (e) {
            setLoading(false);
            console.error((e as Error).message);
        } finally {
            setSubmitting(false);
        }
    };

    // const onPreview = async () => {
    //     try {
    //         setPreviewLoading(true);
    //         setPreviewData(null);
    //         setPreviewFormValues({ dates, selectedInvestor: formik.values.selectedInvestor }); // Save for download

    //         const formattedDate = `${new Date(dates).getDate().toString().padStart(2, '0')}/${(new Date(dates)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(dates).getFullYear()}`;
    //         const ClientCode = formik.values.selectedInvestor.ClientId;
    //         if (!ClientCode) {
    //             setPreviewLoading(false);
    //             return;
    //         }
    //         const res = await dispatch(
    //             getDashboardReports({
    //                 reportName: L3Report ? "DetailedHoldingReportL3" : 'DetailedHoldingReport',
    //                 ClientCode: ClientCode,
    //                 ToDate: formattedDate,
    //             })
    //         );
    //         const fileObj = Array.isArray(res) ? res[0] : res;
    //         const keys = Object.keys(fileObj);
    //         const bufferKey = keys.find(key => key !== 'fileType' && key !== 'filename');
    //         if (!bufferKey) throw new Error(`No buffer key found in fileObj. Available keys: [${keys.join(', ')}].`);
    //         const bufferObj = fileObj[bufferKey];
    //         if (!bufferObj || !Array.isArray(bufferObj.data)) throw new Error(`bufferObj is invalid or missing data array.`);
    //         const byteArray = Uint8Array.from(bufferObj.data);

    //         // Parse XLSX and render as HTML table
    //         const workbook = XLSX.read(byteArray, { type: 'array' });
    //         const firstSheetName = workbook.SheetNames[0];
    //         if (!firstSheetName) throw new Error("No sheet found");
    //         const worksheet = workbook.Sheets[firstSheetName];
    //         const htmlString = XLSX.utils.sheet_to_html(worksheet);
    //         setPreviewData(htmlString);
    //         setPreviewOpen(true);
    //         setPreviewLoading(false);
    //     } catch (e) {
    //         setPreviewLoading(false);
    //         enqueueSnackbar(`Failed to preview file. ${(e as Error).message || e}`, { variant: 'error' });
    //     }
    // };

    const onDownloadPreview = async () => {
        setDownloadPreviewLoading(true);
        try {
            const { dates, selectedInvestor } = previewFormValues;
            await onSubmit(dates, selectedInvestor.ClientId, () => { console.log("Detailed Holding Report download") });
        } finally {
            setDownloadPreviewLoading(false);
        }
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const initialValues = {
        selectedInvestor: { ClientId: "", clientName: "" },
        dates: new Date(),
        // date: new Date()
    };
    // console.log("initialvalue.date", initialValues.date)
    // const handleSubmit = (values: any) => {
    //     // Handle form submission
    //     // console.log(values.selectedInvestor.OClientID);

    //     onSubmit(values.dates, formik.values.selectedInvestor.ClientId);
    // };

    const handleSubmit = (values: any, { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }) => {
        onSubmit(values.dates, formik.values.selectedInvestor.ClientId, setSubmitting);
    };

    const formik = useFormik({
        initialValues,
        onSubmit: handleSubmit,
    });

    // filteredInvestorDetails?.map((i, index) => {
    // const demo = () => {
    //     console.log("demo called")
    // }

    return (
        <ReportsRightLayout >
            <Typography
                sx={{
                    color: 'text.secondary',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    fontWeight: 500,
                    lineHeight: 1.3,
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    display: 'block',
                    wordBreak: 'break-word',
                    md: { xs: 2, sm: 3 },
                }}
            >
                Detailed Holding Report
            </Typography>

            <Formik
                validationSchema={validationSchemaPortfolioSummary}
                initialValues={{
                    date: new Date(),
                    // fileType: 'pdf',
                }}
                onSubmit={() => { onSubmit(dates, formik.values.selectedInvestor.ClientId, () => { (true) }) }}>
                {({ values, setFieldValue, errors }): {
                } => (
                    <Form>
                        <ReportSectionContainer>
                            <Stack>
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: '22px',
                                        letterSpacing: '0.01em',
                                    }}>
                                    Select Investor(s)
                                </Typography>

                                <Select
                                    name={'reportOptions'}
                                    label="Select Investor"
                                    MenuProps={MenuProps}
                                    value={formik.values.selectedInvestor.ClientId || ''}
                                    onChange={async (e) => {
                                        setL3l4Flag('N');
                                        setl3Report(false);

                                        const selectedInvestor = investorList.find(
                                            (investor: any) => investor.OClientID === e.target.value
                                        );
                                        const data = {
                                            ClientId: selectedInvestor?.OClientID,
                                            clientName: selectedInvestor?.I_InvName
                                        };
                                        formik.setFieldValue('selectedInvestor', data);

                                        const requestBody = {
                                            "ClientCode": selectedInvestor?.OClientID
                                        };
                                        (async function () {
                                            try {
                                                const response = (await dispatch(getClientL3L4_Config(requestBody)) as unknown as ClientL3L4_ConfigResponse);
                                                if (response.Table && response.Table.length > 0) {
                                                    setL3l4Flag(response.Table[0].flag);
                                                }

                                            } catch (e) {
                                                console.log((e as Error).message);
                                            }
                                        })();

                                        try {
                                            const response = (await dispatch(getAcountIDBasedonClientID(requestBody)) as unknown as AcountIDBasedonClientIDResponse);
                                            if (response.OAccountID.length > 0) {
                                                if (response.OAccountID.length > 1) {
                                                    setWAccountIDFlag(true);
                                                } else {
                                                    setWAccountIDFlag(false);
                                                }
                                                setWAccountsData(response);
                                                setWAccountId(response.OAccountID[0]?.AccountIdentifier);
                                            } else {
                                                setWAccountIDFlag(false);
                                                setWAccountsData(null);
                                                setWAccountId(null);
                                            }
                                        } catch (e) {
                                            setWAccountIDFlag(false);
                                            setWAccountsData(null);
                                            setWAccountId(null);
                                            console.log((e as Error).message);
                                        }
                                    }}
                                >
                                    {console.log("dashBoardMetricsData", dashBoardMetricsData)}
                                    {investorList.map((i: any, index: any) => (
                                        <MenuItem value={i.OClientID} key={index}>
                                            {i.I_InvName}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {
                                    l3l4Flag == "Y" &&
                                    <FormControl component="fieldset" style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                                        <FormGroup aria-label="position">
                                            <FormControlLabel
                                                value="clientLevelReport"
                                                checked={L3Report}
                                                onChange={(_, checked) => {
                                                    setl3Report(!L3Report);
                                                }}
                                                control={<Checkbox />}
                                                label="Client Level Report"
                                                labelPlacement="end"
                                                disabled={l3l4Flag === "N"}
                                            />
                                        </FormGroup>
                                    </FormControl>
                                }
                                {wAccountIDFlag && (
                                    <Stack>
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                fontWeight: 400,
                                                lineHeight: '22px',
                                                letterSpacing: '0.01em',
                                            }}>
                                            Account Number
                                        </Typography>
                                        <FormControl sx={{ m: 1, minWidth: 250 }}>
                                            <Select
                                                labelId="demo-simple-select-accNumber-label"
                                                id="demo-simple-select-accNumber"
                                                sx={{
                                                    fontSize: '14px',
                                                    fontWeight: 400,
                                                    lineHeight: '22px',
                                                    letterSpacing: '0.01em',
                                                }}
                                                onChange={(event) => setWAccountId(event.target.value)}
                                                value={wAccountId}
                                            >
                                                {wAccountsData?.OAccountID?.map((i: any, index: any) => (
                                                    <MenuItem value={i.AccountIdentifier} key={i.AccountIdentifier}>
                                                        {i.AccountIdentifier}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Stack>
                                )}
                            </Stack>
                        </ReportSectionContainer>

                        <ReportSectionContainer>
                            <Stack>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Select Date"
                                        format="DD-MM-YYYY"
                                        value={dayjs(dates)}
                                        maxDate={dayjs(currentDate)}
                                        onChange={(date: any) =>
                                            setDates(date.format("YYYY-MM-DD"))
                                        }
                                    />
                                </LocalizationProvider>
                            </Stack>
                        </ReportSectionContainer>

                        <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} sx={{ m: 2 }}>
                            <MFSubmitButton
                                label="Download"
                                loadingEnable={loading}
                            // disabled={loading || previewLoading}
                            />
                            {/* <MFSubmitButton
                                label="Preview"
                                loadingEnable={previewLoading}
                                // disabled={loading || previewLoading}
                                onClick={onPreview}
                            /> */}
                        </Stack>
                    </Form>
                )}
            </Formik>

            {/* Detailed Holding Report preview */}
            <Dialog
                open={previewOpen}
                onClose={() => { setPreviewOpen(false); setPreviewData(null); }}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        width: '96vw',
                        maxWidth: '1200px',
                        minWidth: '320px',
                        height: '92vh',
                        maxHeight: '900px',
                        minHeight: '320px',
                        m: '2vw',
                        p: 0,
                        overflow: 'hidden',
                        borderRadius: '12px',
                        boxSizing: 'border-box',
                    }
                }}
            >
                <DialogTitle sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    pb: 1,
                    borderBottom: '1px solid #eee',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    bgcolor: 'background.paper',
                    px: '2vw',
                    fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                        Detailed Holding Report Preview
                    </Box>
                    {downloadPreviewLoading ? (
                        <Box sx={{ width: 80, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <LinearBufferLoader />
                        </Box>
                    ) : (
                        <IconButton
                            sx={{ mr: 2 }}
                            onClick={onDownloadPreview}
                            title="Download"
                        >
                            <DownloadIcon />
                        </IconButton>
                    )}
                    <IconButton onClick={() => { setPreviewOpen(false); setPreviewData(null); }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0, position: 'relative', height: 'calc(92vh - 56px)', minHeight: '200px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    {previewData && (
                        <Box sx={{
                            flex: 1,
                            height: '100%',
                            overflowY: 'auto',
                            background: '#f5f5f6',
                            p: 1,
                            width: '100%',
                            '& table': {
                                borderCollapse: 'collapse',
                                minWidth: 600,
                                maxWidth: '100%',
                                fontFamily: '"Segoe UI", Arial, Helvetica, sans-serif',
                                fontSize: { xs: '11px', sm: '12px', md: '13px' },
                                color: '#222',
                            },
                            '& th, & td': {
                                border: '1px solid #bcbcbc',
                                padding: { xs: '4px 6px', sm: '6px 8px' },
                                textAlign: 'left',
                                backgroundColor: '#fff',
                            },
                            '& th': {
                                backgroundColor: '#f3f6fa',
                                fontWeight: 600,
                            },
                            '& tr:nth-of-type(even) td': {
                                backgroundColor: '#f9fbfc',
                            }
                        }}
                            dangerouslySetInnerHTML={{ __html: previewData }}
                        />
                    )}
                    {!previewLoading && !previewData && (
                        <Typography>No preview available.</Typography>
                    )}
                </DialogContent>
            </Dialog>
        </ReportsRightLayout>
    );
    // }
};
